import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import ExecutiveSummary from "./pages/ExecutiveSummary";
import ProtectedRoute from "./components/ProtectedRoute";

const App = () => (
  <BrowserRouter>
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <ExecutiveSummary />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </BrowserRouter>
);

export default App;
